import { toast } from 'react-toastify';
import API from 'api/API';
import { DraftStatus, SetDraftResponse } from 'api/Responses/SetResponses';

export type SetAction = 'save' | 'submit' | 'approve' | 'merge' | 'delete' | 'rejectPending' | 'rejectReview' | 'edit';

export const setActionSuccess: { [key in SetAction]: string } = {
  save: 'Draft saved',
  submit: 'Draft submitted',
  approve: 'Draft approved',
  merge: 'Draft merged',
  delete: 'Draft deleted',
  rejectPending: 'Draft rejected',
  rejectReview: 'Draft rejected',
  edit: 'Draft edit',
};

const validateDraft = (set: SetDraftResponse): void => {
  // We require JME group to be set.
  if (!set.jme_group) {
    throw new Error('Set group cannot be empty');
  }

  return;
};

export const setActionSwitch = async (action: SetAction, set: SetDraftResponse): Promise<void> => {
  switch (action) {
    case 'save':
      await API.set.save(set.code, set);
      await API.set.submit(set.code, set.status);
      break;
    case 'submit':
      validateDraft(set);

      await API.set.save(set.code, set);
      await API.set.submit(set.code, DraftStatus.REVIEW);
      break;
    case 'approve':
      validateDraft(set);

      await API.set.save(set.code, set);
      await API.set.submit(set.code, DraftStatus.PENDING);
      break;
    case 'merge':
      validateDraft(set);

      await API.set.save(set.code, set);
      await API.set.validate(set.code);
      await API.set.merge(set.code);
      break;
    case 'delete':
      await API.set.remove(set.code);
      break;
    case 'rejectReview':
      await API.set.submit(set.code, DraftStatus.DRAFT);
      break;
    case 'rejectPending':
      await API.set.submit(set.code, DraftStatus.DRAFT);
  }

  toast.success(setActionSuccess[action]);
};
